import api from "../services/api";

// Login do usuário
export const loginUser = async (data) => {
    try {
        const response = await api.post('/auth/login', data);
        return response;
    } catch (error) {
        console.error('Erro ao fazer login:', error?.response?.data);
        throw error;
    }
}

// Criar novo usuário
export const createUser = async (data) => {
    try {
        const response = await api.post('/register', data);
        return response;
    } catch (error) {
        console.error('Erro ao criar usuário:', error?.response?.data);
        throw error;
    }
}

// Verificar código de verificação
export const verifyCode = async (data) => {
    try {
        const response = await api.post('/verify-code', data);
        return response;
    } catch (error) {
        console.error('Erro ao verificar código:', error?.response?.data);
        throw error;
    }
}

// Reenviar código de verificação
export const resendVerificationCode = async (data) => {
    try {
        const response = await api.post('/resend-code', data);
        return response;
    } catch (error) {
        console.error('Erro ao reenviar código:', error?.response?.data);
        throw error;
    }
}

// Gerar código para recuperação de senha
export const generateForgotPasswordCode = async (data) => {
    try {
        const response = await api.post('/generate-forgot-password-code', data);
        return response;
    } catch (error) {
        console.error('Erro ao gerar código de recuperação:', error?.response?.data);
        throw error;
    }
}

// Verificar código de recuperação de senha
export const verifyResetPasswordCode = async (data) => {
    try {
        const response = await api.post('/verify-password-code', data);
        return response;
    } catch (error) {
        console.error('Erro ao verificar código de recuperação:', error?.response?.data);
        throw error;
    }
}

// Redefinir senha
export const resetPassword = async (data) => {
    try {
        const response = await api.post('/reset-password', data);
        return response;
    } catch (error) {
        console.error('Erro ao redefinir senha:', error?.response?.data);
        throw error;
    }
}

// Obter todos os usuários
export const getAllUsers = async () => {
    try {
        const response = await api.get('/');
        return response;
    } catch (error) {
        console.error('Erro ao obter usuários:', error?.response?.data);
        throw error;
    }
}

// Obter usuário específico
export const getUserById = async (id) => {
    try {
        const response = await api.get(`/user/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao obter usuário:', error?.response?.data);
        throw error;
    }
}

// Atualizar usuário
export const updateUser = async (id, data) => {
    try {
        const response = await api.put(`/user/${id}`, data);
        return response;
    } catch (error) {
        console.error('Erro ao atualizar usuário:', error?.response?.data);
        throw error;
    }
}

// Deletar usuário
export const deleteUser = async (id) => {
    try {
        const response = await api.delete(`/user/${id}`);
        return response;
    } catch (error) {
        console.error('Erro ao deletar usuário:', error?.response?.data);
        throw error;
    }
}

// Gerar URL de autenticação Google
export const getGoogleAuthUrl = async (userId) => {
    try {
        const response = await api.get(`/auth-url?id=${userId}`);
        return response;
    } catch (error) {
        console.error('Erro ao gerar URL do Google:', error?.response?.data);
        throw error;
    }
}

// Renovar token
export const refreshToken = async () => {
    try {
        const response = await api.post('/refresh-token');
        return response;
    } catch (error) {
        console.error('Erro ao renovar token:', error?.response?.data);
        throw error;
    }
}